import { required, minLength, maxLength, matches } from 'services/validators'

export default values => {
  const errors = {}
  if (!required(values.firtsPassword)) {
    errors.firtsPassword = 'Contraseña requerida'
  } else if (!minLength(values.firtsPassword, 8)) {
    errors.firtsPassword = 'Contraseña muy corta'
  } else if (!maxLength(values.firtsPassword, 20)) {
    errors.firtsPassword = 'Contraseña muy larga'
  }
  if (!required(values.confirmPassword)) {
    errors.confirmPassword = 'Confirmación requerida'
  }
  if (!matches(values.firtsPassword, values.confirmPassword)) {
    errors.confirmPassword = 'Error en la confirmación'
  }
  return errors
}
